import { render, staticRenderFns } from "./ProjectsCount.vue?vue&type=template&id=11cd49c2&"
import script from "./ProjectsCount.vue?vue&type=script&lang=ts&"
export * from "./ProjectsCount.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports